import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { Breadcrumbs, Skeleton } from '@mui/material';
import { BACK_BUTTON_STYLES } from '@/layouts/MainLayout/utils/constants';
import { useEntitiesList } from '@/providers/EntitiesListContextProvider/EntitiesListContext.hooks';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { EntityLogo } from '@/components/EntityLogo/EntityLogo';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import {
  StyledToolbarWrappingBackButton,
  StyledBackButton,
  StyledBackArrowIcon,
  StyledHeader,
  StyledCentredTitleWithTooltipWrapper,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';
import { ERoutes } from '@/types/routes';

export const ReservesMonitoringHeader = () => {
  const navigate = useNavigate();
  const { isDesktop } = useBreakpointsCtx();
  const { agioId } = useParams();
  const { isEntitiesListLoading, getDisplayNameByEntityValue } = useEntitiesList();

  const breadcrumbs = [
    <StyledAgioH1 key={0} noWrap color="customSecondary.primary.DEFAULT">
      {isEntitiesListLoading ? (
        <Skeleton variant="text" animation="wave" width="160px" />
      ) : (
        getDisplayNameByEntityValue(agioId || '')
      )}
    </StyledAgioH1>,
  ];

  return (
    <StyledHeader position="static" isDesktop={isDesktop}>
      <StyledToolbarWrappingBackButton>
        <StyledBackButton
          onClick={() => navigate(`${ERoutes.STABLECOINS}`)}
          skipTypography
          disableRipple
          blockHoverBehavior
          sx={BACK_BUTTON_STYLES}
        >
          <StyledBackArrowIcon />
        </StyledBackButton>

        <StyledCentredTitleWithTooltipWrapper>
          <EntityLogo companyName={agioId || ''} height="24px" />
          <Breadcrumbs
            separator="›"
            aria-label="breadcrumb"
            color="customSecondary.primary.DEFAULT"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </StyledCentredTitleWithTooltipWrapper>
      </StyledToolbarWrappingBackButton>
    </StyledHeader>
  );
};
